mutation GenerateAllDafStatements($dafStatementInput: DafStatementInput!) {
  generateAllDafStatements(input: { dafStatementInput: $dafStatementInput }) {
    success
  }
}
